export default __webpack_public_path__ + "static/media/732.4760d786.png";